import { SET_BASE_DATA } from '../constants'
import update from 'immutability-helper'

const InitState = {
  articleBadges: {},
  articleTags: [],
  authors: [],
  brands: [],
  categories: [],
  categoryTree: {},
  coverThemes: [],
  merchants: [],
}

export default function (state = InitState, action: any) {
  switch (action.type) {
    case SET_BASE_DATA:
      return update(state, {
        $set: action.payload,
      })
    default:
      return state
  }
}
